// Filter.tsx

import { Box, Checkbox, FormControlLabel, FormGroup } from '@mui/material';

interface FilterProps {
  // Now filterType is always a string array in the new structure
  filterType: string[];

  // Add this prop to match what FilterSelection is passing
  filteredOptions?: string[];

  handleCheckboxChange: (
    elem: string,
    setList: React.Dispatch<React.SetStateAction<string[]>>,
    list: string[],
    paramKey: string
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void;

  list: string[];
  setList: React.Dispatch<React.SetStateAction<string[]>>;
  keyName: string;
  paramKey: string;
}

const Filter = ({
                  filterType,
                  filteredOptions, // Add this parameter (optional for backward compatibility)
                  handleCheckboxChange,
                  list,
                  setList,
                  keyName,
                  paramKey,
                }: FilterProps) => {
  return (
    <Box
      sx={{
        overflowY: 'auto',
        maxHeight: '20.5rem',
      }}
    >
      <FormGroup>
        {filterType
          .slice()
          .sort((a, b) => a.localeCompare(b))
          .map((elem) => {
            // With the new structure, all elements are strings
            const label = elem;
            const value = elem;
            const isChecked = list.includes(value);

            return (
              <FormControlLabel
                key={elem}
                control={
                  <Checkbox
                    checked={isChecked}
                    onChange={handleCheckboxChange(
                      value,
                      setList,
                      list,
                      paramKey
                    )}
                  />
                }
                label={label}
              />
            );
          })}
      </FormGroup>
    </Box>
  );
};

export default Filter;